import { logEvent } from 'firebase/analytics';
import { analytics } from '../config/firebase';

// Analytics utility functions for tracking user interactions
export const trackEvent = (eventName: string, parameters?: Record<string, unknown>) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
    console.log(`Analytics: ${eventName}`, parameters);
  }
};

// Page view tracking
export const trackPageView = (pageName: string, pageTitle?: string) => {
  trackEvent('page_view', {
    page_name: pageName,
    page_title: pageTitle || pageName,
    page_location: window.location.href,
  });
};

// Button click tracking
export const trackButtonClick = (buttonName: string, buttonLocation?: string) => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: buttonLocation,
  });
};

// Feature interaction tracking
export const trackFeatureInteraction = (featureName: string, action: string) => {
  trackEvent('feature_interaction', {
    feature_name: featureName,
    action: action,
  });
};

// CTA tracking
export const trackCTAClick = (ctaName: string, ctaLocation: string) => {
  trackEvent('cta_click', {
    cta_name: ctaName,
    cta_location: ctaLocation,
  });
};

// Navigation tracking
export const trackNavigation = (fromPage: string, toPage: string, navigationMethod: string) => {
  trackEvent('navigation', {
    from_page: fromPage,
    to_page: toPage,
    navigation_method: navigationMethod,
  });
};

// User engagement tracking
export const trackEngagement = (contentType: string, engagementType: string, value?: number) => {
  trackEvent('engagement', {
    content_type: contentType,
    engagement_type: engagementType,
    value: value,
  });
};